import { NgStyle } from "@angular/common";
import { Component, input } from "@angular/core";
import { InitialsPipe } from "../../pipes/initials.pipe";

@Component({
	selector: "app-avatar-initials",
	imports: [InitialsPipe, NgStyle],
	templateUrl: "./avatar-initials.component.html",
})
export class AvatarInitialsComponent {
	name = input.required<string>();
	size = input<number>(24);
	width = input<number>();
	height = input<number>();
	bgColor = input<string>("#f45c2c");
	textColor = input<string>("white");
	radius = input<number>();

	get avatarStyle() {
		return {
			"width.px": this.width() || this.size(),
			"height.px": this.height() || this.size(),
			"background-color": this.bgColor(),
			"border-radius.px": this.radius() || this.size(),
			color: this.textColor(),
			"font-size.px": (this.width() || this.size()) / 2,
		};
	}

	// getBgColor(): string {
	//   const namesFirstCharCode = this.name().toUpperCase().charCodeAt(0);

	//   if (namesFirstCharCode > 85) {
	//     return '#8e24aa';
	//   } else if (namesFirstCharCode > 80) {
	//     return '#f4511e';
	//   } else if (namesFirstCharCode > 75) {
	//     return '#c0ca33';
	//   } else if (namesFirstCharCode > 70) {
	//     return '#d81b60';
	//   }

	//   return this.bgColor();
	// }
}
